/**
 * DOG1 LP-Dental Buy-Box (LP-3, ein Selektor, quantity=1)
 *
 * ARCHITEKTUR:
 *   - Zwei Radio-Groups (Größe / Modus) reagieren auf change-Events.
 *     LP-3 hat den separaten Quantity-Selektor entfernt — Größe ist die
 *     einzige Variant-Achse, Quantity ist beim Add hardcoded auf 1.
 *   - Preis-Display aktualisiert sich live (abo-sensitiv)
 *   - Badge pro Größe: mode-ABHÄNGIG (LP-3 Update — PDP-Original-Math).
 *     Vergleicht aktuellen Pro-Dose-Preis (inkl. ggf. Abo-Rabatt) gegen
 *     1×200g-Einmalkauf-Referenz. Im Abo-Modus fließt Abo-Rabatt mit ein.
 *   - URL-Sync: variant + selling_plan in der Browser-URL
 *   - ATC ist <button type="button"> (kein <form>, kein name="add")
 *     → unsichtbar für Opus' Click-Capture
 *   - ATC-Klick:
 *     1) /cart/update.js mit qty 0 für ALLE Dental-Varianten + Löffel
 *        (entfernt frühere LP-Items, andere Produkte bleiben)
 *     2) /cart/add.js mit MULTI-Item-JSON-Body — Dental (gewählte
 *        Variante, qty 1, ggf. selling_plan) + Löffel (qty 1, KEIN
 *        selling_plan, auch im Abo). Atomar: beide rein oder beide raus.
 *     3) bei 2xx: window.location.href = '/checkout'
 *        bei Fehler: aria-live-Hinweis, Button wieder enabled
 *   - KEINE cart:*-Events werden dispatched → Opus' Listener feuern nicht
 *
 * APPSTLE-SELLING-PLAN:
 *   Form-Field-Name ist 'selling_plan' (Shopify-Cart-API-Spec). Bei Abo-Modus
 *   wird dieser Key gesetzt, bei Einmalkauf weggelassen. Der POST geht durch
 *   denselben Endpoint wie die PDP — Appstle bindet den Plan dort serverseitig.
 *
 * ENTKOPPLUNG VON PDP:
 *   - Eigener Container .lp-buybox, eigene IDs (lp-buybox-*)
 *   - History-API-Patch GLOBAL geteilt via window.__dog1HistoryPatched
 *   - Keine Reuse von PDP-Klassen / -DOM-IDs
 */
(function () {
  'use strict';

  var ROOT = document.querySelector('.lp-buybox');
  if (!ROOT) return;

  var SELLING_PLAN_ID = ROOT.dataset.sellingPlanId || '';
  var ABO_DISCOUNT = parseFloat(ROOT.dataset.aboDiscount || '0.15');
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: CURRENCY,
    }).format(cents / 100);
  }

  // ---------- DOM ----------
  var sizeRadios = ROOT.querySelectorAll('input[name="lp-buybox-size"]');
  var modeRadios = ROOT.querySelectorAll('input[name="lp-buybox-mode"]');
  var atcBtn = ROOT.querySelector('[data-lp-buybox-atc]');
  var atcLabel = ROOT.querySelector('[data-lp-buybox-atc-label]');
  var atcError = ROOT.querySelector('[data-lp-buybox-error]');
  var totalSlot = ROOT.querySelector('[data-lp-buybox-total]');
  var perUnitSlot = ROOT.querySelector('[data-lp-buybox-per-unit]');
  var saveSlot = ROOT.querySelector('[data-lp-buybox-save]');
  var modeAboBadge = ROOT.querySelector('[data-lp-buybox-abo-badge]');

  var ATC_LABEL_DEFAULT = atcLabel ? atcLabel.textContent.trim() : 'In den Warenkorb';
  var ATC_LABEL_LOADING = 'Wird hinzugefügt …';

  // Alle Dental-Varianten-IDs für „nur letzte Auswahl behalten"-Logik.
  // Quelle: data-variant-id Attribute auf den Size-Cards (per Variante eine).
  // KEIN Hardcode — ändert sich automatisch mit der Produkt-Bindung.
  var DENTAL_VARIANT_IDS = Array.prototype.slice
    .call(ROOT.querySelectorAll('[data-variant-id]'))
    .map(function (el) { return el.dataset.variantId; })
    .filter(function (id) { return id; });

  // Edelstahl-Dosierlöffel (0€-Variante), wird bei jedem LP-Add
  // automatisch als Beigabe mitgelegt. Hardcoded laut Hermann-Auftrag.
  // ACHTUNG: Variant-ID, NICHT Product-ID. Verwechslung führte zu HTTP 422
  // bei /cart/update.js und /cart/add.js (Diagnose 2026-05-25):
  //   gid://shopify/Product/8787232457029         = Dosierlöffel-Produkt
  //   gid://shopify/ProductVariant/47531635736901 = Default-Variante (0€)
  // /cart-Endpoints akzeptieren ausschließlich Variant-IDs.
  // Variant-ID-Änderung erfordert Edit hier (Eine-Zeile-Migration).
  var SPOON_VARIANT_ID = '47531635736901';

  // Beim Cleanup mitwegnehmen, damit nicht mehrere Löffel auflaufen.
  var REPLACEABLE_VARIANT_IDS = DENTAL_VARIANT_IDS.concat([SPOON_VARIANT_ID]);

  // ---------- Helpers ----------
  function getSelectedVariantCard() {
    var checked = ROOT.querySelector('input[name="lp-buybox-size"]:checked');
    return checked ? checked.closest('[data-variant-id]') : null;
  }

  function getSelectedMode() {
    var checked = ROOT.querySelector('input[name="lp-buybox-mode"]:checked');
    return checked ? checked.value : 'einmal';
  }

  function getUnitCountFromCard(card) {
    if (!card) return 1;
    var title = card.dataset.variantTitle || '';
    var match = title.match(/^(\d+)x\b/i);
    if (match) return parseInt(match[1], 10);
    var fallback = parseInt(card.dataset.unitCount, 10);
    return fallback > 0 ? fallback : 1;
  }

  // ---------- Bundle-Referenz für mode-independent Badges ----------
  // Pro-Dose-Preis der kleinsten Variante (1×), IMMER Einmalkauf-Basis.
  // Mode-Wechsel verändert die Badge-Werte NICHT — Abo-Rabatt erscheint
  // separat im Mode-Toggle-Pill.
  var BASE_EINMAL_PER_UNIT = (function () {
    var minUnits = Infinity;
    var ref = 0;
    ROOT.querySelectorAll('[data-variant-id]').forEach(function (sizeCard) {
      var units = getUnitCountFromCard(sizeCard);
      var basePrice = parseInt(sizeCard.dataset.basePrice, 10);
      if (units > 0 && basePrice > 0 && units < minUnits) {
        minUnits = units;
        ref = basePrice / units;
      }
    });
    return ref;
  })();

  // ---------- Preise ----------
  function renderPrices() {
    var card = getSelectedVariantCard();
    if (!card) return;
    var basePrice = parseInt(card.dataset.basePrice, 10);
    if (!basePrice) return;

    var mode = getSelectedMode();
    var unitCount = getUnitCountFromCard(card);

    var effectiveVariantPrice = mode === 'abo' ? basePrice * (1 - ABO_DISCOUNT) : basePrice;
    var perUnit = effectiveVariantPrice / unitCount;
    var savings = basePrice - effectiveVariantPrice;

    // Total = Preis der gewählten Variante (quantity ist hardcoded 1).
    if (totalSlot) totalSlot.textContent = formatMoney(effectiveVariantPrice);
    if (perUnitSlot) perUnitSlot.textContent = formatMoney(perUnit);

    if (saveSlot) {
      if (mode === 'abo' && savings > 0) {
        saveSlot.textContent = 'Du sparst ' + formatMoney(savings);
        saveSlot.hidden = false;
      } else {
        saveSlot.hidden = true;
        saveSlot.textContent = '';
      }
    }

    ROOT.querySelectorAll('[data-variant-id]').forEach(function (sizeCard) {
      var sBase = parseInt(sizeCard.dataset.basePrice, 10);
      var sUnits = getUnitCountFromCard(sizeCard);
      if (!sBase || !sUnits) return;

      // Pro-Dose-Preis-DISPLAY ist mode-abhängig.
      var sEff = mode === 'abo' ? sBase * (1 - ABO_DISCOUNT) : sBase;
      var sPerUnit = sEff / sUnits;
      var sPerSlot = sizeCard.querySelector('[data-lp-buybox-size-per-unit]');
      if (sPerSlot) sPerSlot.textContent = formatMoney(sPerUnit);

      // Badge ist mode-ABHÄNGIG (LP-3 Update, PDP-Original-Mechanik):
      // Vergleicht aktuellen Pro-Dose-Preis (mit ggf. Abo-Rabatt) gegen
      // die Einmalkauf-1×-Referenz. Im Abo-Modus fließt der Abo-Rabatt
      // mit ein → Badges werden höher beim Mode-Wechsel.
      // Hinweis: In Abo-Mode zeigt 1× damit denselben Wert wie die
      // separate Abo-Pille im Mode-Toggle (Doppel-Anzeige).
      var sBadge = sizeCard.querySelector('[data-lp-buybox-size-badge]');
      if (sBadge) {
        var savingsPct = BASE_EINMAL_PER_UNIT
          ? Math.round(((BASE_EINMAL_PER_UNIT - sPerUnit) / BASE_EINMAL_PER_UNIT) * 100)
          : 0;
        if (savingsPct > 0) {
          sBadge.textContent = '-' + savingsPct + '%';
          sBadge.hidden = false;
        } else {
          sBadge.hidden = true;
          sBadge.textContent = '';
        }
      }
    });

    // Abo-Rabatt-Pill (im Mode-Toggle, separat vom Größen-Badge).
    if (modeAboBadge) {
      var modePct = Math.round(ABO_DISCOUNT * 100);
      modeAboBadge.textContent = '-' + modePct + '%';
    }
  }

  // ---------- URL-Sync (nur informativ — Permalink wird nicht mehr genutzt) ----------
  function syncUrlFromState() {
    var card = getSelectedVariantCard();
    var mode = getSelectedMode();
    var url = new URL(window.location.href);

    if (card && card.dataset.variantId) {
      url.searchParams.set('variant', card.dataset.variantId);
    }
    if (mode === 'abo' && SELLING_PLAN_ID) {
      url.searchParams.set('selling_plan', SELLING_PLAN_ID);
    } else {
      url.searchParams.delete('selling_plan');
    }
    history.replaceState({}, '', url);
  }

  function readModeFromUrl() {
    return new URLSearchParams(window.location.search).has('selling_plan') ? 'abo' : 'einmal';
  }

  function applyModeFromUrl() {
    var urlMode = readModeFromUrl();
    var matching = ROOT.querySelector('input[name="lp-buybox-mode"][value="' + urlMode + '"]');
    if (matching && !matching.checked) matching.checked = true;
  }

  // ---------- History-Patch (idempotent, geteilt mit PDP) ----------
  if (!window.__dog1HistoryPatched) {
    window.__dog1HistoryPatched = true;
    var origPush = history.pushState;
    history.pushState = function () {
      var ret = origPush.apply(this, arguments);
      window.dispatchEvent(new Event('dog1:urlchange'));
      return ret;
    };
    var origReplace = history.replaceState;
    history.replaceState = function () {
      var ret = origReplace.apply(this, arguments);
      window.dispatchEvent(new Event('dog1:urlchange'));
      return ret;
    };
  }

  // ---------- ATC: /cart/add.js + Checkout-Redirect ----------
  function showError(msg) {
    if (!atcError) {
      window.alert(msg);
      return;
    }
    atcError.textContent = msg;
    atcError.hidden = false;
  }

  function clearError() {
    if (!atcError) return;
    atcError.hidden = true;
    atcError.textContent = '';
  }

  function setBusy(busy) {
    if (!atcBtn) return;
    if (busy) {
      atcBtn.setAttribute('aria-busy', 'true');
      atcBtn.setAttribute('disabled', 'true');
      if (atcLabel) atcLabel.textContent = ATC_LABEL_LOADING;
    } else {
      atcBtn.removeAttribute('aria-busy');
      atcBtn.removeAttribute('disabled');
      if (atcLabel) atcLabel.textContent = ATC_LABEL_DEFAULT;
    }
  }

  /**
   * Schritt 1: alle Dental-Lines UND alle Löffel-Lines aus dem Cart
   * entfernen (egal welche Größe/Modus). Andere Produkte bleiben
   * unberührt. /cart/update.js mit updates[<variant_id>]=0 pro ID.
   * Single-XHR, atomar, Shopify-Standard.
   *
   * Falls keine Dental-Varianten bekannt (Produkt nicht zugewiesen): skip.
   */
  function removeExistingItems(callback) {
    if (!DENTAL_VARIANT_IDS.length) {
      callback(true);
      return;
    }
    var formData = new FormData();
    REPLACEABLE_VARIANT_IDS.forEach(function (id) {
      formData.append('updates[' + id + ']', '0');
    });

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/update.js', true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(true);
        return;
      }
      callback(false, 'Cart-Update fehlgeschlagen (HTTP ' + xhr.status + ').');
    };
    xhr.onerror = function () {
      callback(false, 'Netzwerk-Fehler beim Cart-Update.');
    };
    xhr.send(formData);
  }

  /**
   * Schritt 2: Dental-Variante + Löffel in EINEM /cart/add.js POST adden.
   * Multi-Item-Format ist atomic — entweder beide Lines rein oder beide
   * raus. Keine Race-Condition zwischen Dental und Löffel.
   *
   * Format: JSON-Body { items: [{id, quantity, selling_plan?}, ...] }
   * XHR statt fetch (Opus-Drawer-Bypass — siehe Header-Kommentar).
   *
   * Löffel trägt KEINEN selling_plan, auch wenn das Dental im Abo läuft.
   */
  function addCurrentSelection(variantId, qty, mode, callback) {
    var dentalItem = {
      id: parseInt(variantId, 10),
      quantity: qty
    };
    if (mode === 'abo' && SELLING_PLAN_ID) {
      dentalItem.selling_plan = parseInt(SELLING_PLAN_ID, 10);
    }

    var spoonItem = {
      id: parseInt(SPOON_VARIANT_ID, 10),
      quantity: 1
    };

    var body = JSON.stringify({ items: [dentalItem, spoonItem] });

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        callback(true);
        return;
      }
      var msg = 'Add-to-Cart fehlgeschlagen (HTTP ' + xhr.status + ').';
      try {
        var parsed = JSON.parse(xhr.responseText);
        msg = parsed.description || parsed.message || msg;
      } catch (_) { /* responseText war kein JSON */ }
      callback(false, msg);
    };
    xhr.onerror = function () {
      callback(false, 'Es gab einen Netzwerk-Fehler. Bitte versuche es erneut.');
    };
    xhr.send(body);
  }

  function handleAtcClick(e) {
    e.preventDefault();
    if (!atcBtn || atcBtn.hasAttribute('disabled')) return;

    var card = getSelectedVariantCard();
    if (!card) {
      showError('Bitte wähle eine Größe.');
      return;
    }

    var variantId = card.dataset.variantId;
    var mode = getSelectedMode();
    // Quantity ist LP-3-seitig hardcoded auf 1 — Größe ist die
    // einzige Variant-Achse (Bundle 1×/2×/3× kommt aus der Variante selbst).
    var qty = 1;

    clearError();
    setBusy(true);

    // Sequentiell: erst Dental+Löffel-Lines killen, dann beide in EINEM
    // multi-item Request adden, dann redirecten. Callbacks statt Promise-
    // Chain — kompatibel mit XHR und vermeidet unbeabsichtigtes
    // fetch-Wrapping durch Opus.
    removeExistingItems(function (removeOk, removeErr) {
      if (!removeOk) {
        setBusy(false);
        showError(removeErr);
        return;
      }
      addCurrentSelection(variantId, qty, mode, function (addOk, addErr) {
        if (!addOk) {
          setBusy(false);
          showError(addErr);
          return;
        }
        // Maximale Synchronität: direkt navigieren, kein Event-Dispatch.
        window.location.href = '/checkout';
      });
    });
  }

  // ---------- Wiring ----------
  function handleAnyChange() {
    renderPrices();
    syncUrlFromState();
    clearError();
  }

  sizeRadios.forEach(function (r) { r.addEventListener('change', handleAnyChange); });
  modeRadios.forEach(function (r) { r.addEventListener('change', handleAnyChange); });

  if (atcBtn) atcBtn.addEventListener('click', handleAtcClick);

  window.addEventListener('dog1:urlchange', function () {
    applyModeFromUrl();
    renderPrices();
  });
  window.addEventListener('popstate', function () {
    applyModeFromUrl();
    renderPrices();
  });

  // bfcache-Restore-Handler (BUG 2 Fix):
  //   Nach Checkout → Browser-Zurück kann der Browser die LP aus dem
  //   bfcache mit eingefrorenem DOM-Zustand wiederherstellen: ATC-Button
  //   hängt auf aria-busy, evtl. Error-Hinweis sichtbar, Opus-Drawer-
  //   Residual. Wir setzen unseren Button-Zustand hart zurück.
  //   event.persisted === true ⇔ Restore aus bfcache (nicht regulärer Load).
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    setBusy(false);
    clearError();
  });

  // Initial-Render
  applyModeFromUrl();
  renderPrices();
})();
